import BoldIcon from 'style-guide/Icons/RichEditor/Bold';
import BulListIcon from 'style-guide/Icons/RichEditor/BulList';
import H2Icon from 'style-guide/Icons/RichEditor/H2';
import H3Icon from 'style-guide/Icons/RichEditor/H3';
import Highlight from 'style-guide/Icons/RichEditor/Highlight';
import ItalicIcon from 'style-guide/Icons/RichEditor/Italic';
import LinkIcon from 'style-guide/Icons/RichEditor/Link';
import NumListIcon from 'style-guide/Icons/RichEditor/NumList';
import ParagraphIcon from 'style-guide/Icons/RichEditor/Paragraph';
import QuoteIcon from 'style-guide/Icons/RichEditor/Quote';
import StrikeThroughIcon from 'style-guide/Icons/RichEditor/StrikeThrought';
import UnderlineIcon from 'style-guide/Icons/RichEditor/Underline';

export const getMenuActions = ({ editor, setLinkModalVisible }) => [
  {
    name: 'bold',
    title: 'Format Bold',
    icon: <BoldIcon />,
    onSelect: () => editor.chain().focus().toggleMark('bold').run(),
    selected: () => editor.isActive('bold'),
  },
  {
    name: 'italic',
    title: 'Format Italic',
    icon: <ItalicIcon />,
    onSelect: () => editor.chain().focus().toggleMark('italic').run(),
    selected: () => editor.isActive('italic'),
  },
  {
    name: 'underline',
    title: 'Format Underline',
    icon: <UnderlineIcon />,
    onSelect: () => editor.chain().focus().toggleMark('underline').run(),
    selected: () => editor.isActive('underline'),
  },
  {
    name: 'strikethrough',
    title: 'Format StrikeThrough',
    icon: <StrikeThroughIcon />,
    onSelect: () => editor.chain().focus().toggleMark('strike').run(),
    selected: () => editor.isActive('strike'),
    borderAfter: true,
  },

  {
    name: 'Heading 2',
    title: 'Format to H2',
    icon: <H2Icon />,
    onSelect: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),
    selected: () => editor.isActive('heading', { level: 2 }),
  },
  {
    name: 'Heading 3',
    title: 'Format to H3',
    icon: <H3Icon />,
    onSelect: () => editor.chain().focus().toggleHeading({ level: 3 }).run(),
    selected: () => editor.isActive('heading', { level: 3 }),
  },
  {
    name: 'Paragraph',
    title: 'Format to Paragraph',
    icon: <ParagraphIcon />,
    onSelect: () => editor.chain().setParagraph().run(),
    selected: () => editor.isActive('heading', { level: 1 }),
    borderAfter: true,
  },

  {
    name: 'bulleted-list',
    title: 'Toggle Bullete List',
    icon: <BulListIcon />,
    onSelect: () => editor.chain().focus().toggleBulletList().run(),
    selected: () => editor.isActive('bulletList'),
  },
  {
    name: 'ordered-list',
    title: 'Toggle Ordered List',
    icon: <NumListIcon />,
    onSelect: () => editor.chain().focus().toggleOrderedList().run(),
    selected: () => editor.isActive('orderedList'),
    borderAfter: true,
  },
  {
    name: 'quotation',
    title: 'Toggle Blockquote List',
    icon: <QuoteIcon />,
    onSelect: () => {
      editor.can().unsetBlockquote()
        ? editor.chain().unsetBlockquote().focus().run()
        : editor.chain().setBlockquote().focus().run();
    },
    selected: () => editor.can().unsetBlockquote(),
    borderAfter: true,
  },
  {
    name: 'highlight',
    title: 'Highlight',
    icon: <Highlight width={20} height={20} />,
    onSelect: () =>
      !editor.isActive('highlight')
        ? editor.chain().setHighlight().focus().run()
        : editor.chain().unsetHighlight().focus().run(),
    selected: () => editor.isActive('highlight'),
  },
  {
    name: 'link',
    title: 'Toggle Link',
    icon: <LinkIcon />,
    onSelect: () => setLinkModalVisible(true),
    selected: () => editor.isActive('link'),
  },
];
